export const infoData = {
  gelabs: {
    allText:
      "The chatbot answers questions based primarily on the transcripts uploaded as part of the immersions in Nigeria, Kenya and Senegal. It also refers to specific points regarding Pathways Segment research data added to the platform.\n\nThe chatbot can only respond to questions using relevant data that is available in the above mentioned research notes. Questions where the data required is not available will not generate answers.\n\nResponses are generated using simple vector search, making it unsuitable for broad queries requiring context from extensive or all data. On the other hand, for overly complex queries, results may not be accurate.  Users are encouraged to ask specific questions that pertain to the two hypotheses, or adjacent areas of enquiry.\n\nIt may not provide accurate or complete answers for highly specific data aggregation requests, such as participant lists based on complex criteria.\n\nThe chatbot has been instructed not to infer information such as gender or names to minimize incorrect presumptions. As a result, some queries within the context and training data may remain unanswered.\n\n",
    isLexical: true,
    editorState: {
      root: {
        children: [
          {
            children: [
              {
                children: [
                  {
                    detail: 0,
                    format: 0,
                    mode: "normal",
                    style: "",
                    text: "The chatbot answers questions based primarily on the transcripts uploaded as part of the immersions in Nigeria, Kenya and Senegal. It also refers to specific points regarding Pathways Segment research data added to the platform.",
                    type: "text",
                    version: 1,
                  },
                ],
                direction: "ltr",
                format: "",
                indent: 0,
                type: "listitem",
                version: 1,
                value: 1,
              },
              {
                children: [
                  {
                    detail: 0,
                    format: 0,
                    mode: "normal",
                    style: "",
                    text: "The chatbot can only respond to questions using relevant data that is available in the above mentioned research notes. Questions where the data required is not available will not generate answers.",
                    type: "text",
                    version: 1,
                  },
                ],
                direction: "ltr",
                format: "",
                indent: 0,
                type: "listitem",
                version: 1,
                value: 2,
              },
              {
                children: [
                  {
                    detail: 0,
                    format: 0,
                    mode: "normal",
                    style: "",
                    text: "Responses are generated using simple vector search, making it unsuitable for broad queries requiring context from extensive or all data. On the other hand, for overly complex queries, results may not be accurate.  Users are encouraged to ask specific questions that pertain to the two hypotheses, or adjacent areas of enquiry.",
                    type: "text",
                    version: 1,
                  },
                ],
                direction: "ltr",
                format: "",
                indent: 0,
                type: "listitem",
                version: 1,
                value: 3,
              },
              {
                children: [
                  {
                    detail: 0,
                    format: 0,
                    mode: "normal",
                    style: "",
                    text: "It may not provide accurate or complete answers for highly specific data aggregation requests, such as participant lists based on complex criteria.",
                    type: "text",
                    version: 1,
                  },
                ],
                direction: "ltr",
                format: "",
                indent: 0,
                type: "listitem",
                version: 1,
                value: 4,
              },
              {
                children: [
                  {
                    detail: 0,
                    format: 0,
                    mode: "normal",
                    style: "",
                    text: "The chatbot has been instructed not to infer information such as gender or names to minimize incorrect presumptions. As a result, some queries within the context and training data may remain unanswered.",
                    type: "text",
                    version: 1,
                  },
                ],
                direction: "ltr",
                format: "",
                indent: 0,
                type: "listitem",
                version: 1,
                value: 5,
              },
            ],
            direction: "ltr",
            format: "",
            indent: 0,
            type: "list",
            version: 1,
            listType: "bullet",
            start: 1,
            tag: "ul",
          },
        ],
        direction: "ltr",
        format: "",
        indent: 0,
        type: "root",
        version: 1,
      },
    },
  },
};

export const defaultContent = {
  allText:
    "Welcome to our AI-powered chatbot.\n\nThis chatbot can answer questions based on the information available in our database.\n\nTo get the best responses:\n\nAsk clear, specific questions related to the topics we support.\n\nThe chatbot cannot answer questions outside its knowledge base.\n\nIf an answer feels incomplete or unclear, try rephrasing your question.\n\nYour feedback is valuable and helps us improve the system.",
  isLexical: true,
  editorState: {
    root: {
      children: [
        {
          children: [
            {
              detail: 0,
              format: 1,
              mode: "normal",
              style: "",
              text: "Welcome to our AI-powered chatbot.",
              type: "text",
              version: 1,
            },
          ],
          direction: "ltr",
          format: "",
          indent: 0,
          type: "paragraph",
          version: 1,
        },
        {
          children: [
            {
              detail: 0,
              format: 0,
              mode: "normal",
              style: "",
              text: "This chatbot can answer questions based on the information available in our database.",
              type: "text",
              version: 1,
            },
          ],
          direction: "ltr",
          format: "",
          indent: 0,
          type: "paragraph",
          version: 1,
        },
        {
          children: [
            {
              detail: 0,
              format: 0,
              mode: "normal",
              style: "",
              text: "To get the best responses:",
              type: "text",
              version: 1,
            },
          ],
          direction: "ltr",
          format: "",
          indent: 0,
          type: "paragraph",
          version: 1,
        },
        {
          children: [
            {
              children: [
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: "Ask ",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 1,
                  mode: "normal",
                  style: "",
                  text: "clear, specific questions",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: " related to the topics we support.",
                  type: "text",
                  version: 1,
                },
              ],
              direction: "ltr",
              format: "",
              indent: 0,
              type: "listitem",
              version: 1,
              value: 1,
            },
            {
              children: [
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: "The chatbot ",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 1,
                  mode: "normal",
                  style: "",
                  text: "cannot answer questions outside its knowledge base",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: ".",
                  type: "text",
                  version: 1,
                },
              ],
              direction: "ltr",
              format: "",
              indent: 0,
              type: "listitem",
              version: 1,
              value: 2,
            },
            {
              children: [
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: "If an answer feels ",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 1,
                  mode: "normal",
                  style: "",
                  text: "incomplete or unclear",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: ", try ",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 1,
                  mode: "normal",
                  style: "",
                  text: "rephrasing your question",
                  type: "text",
                  version: 1,
                },
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: ".",
                  type: "text",
                  version: 1,
                },
              ],
              direction: "ltr",
              format: "",
              indent: 0,
              type: "listitem",
              version: 1,
              value: 3,
            },
          ],
          direction: "ltr",
          format: "",
          indent: 0,
          type: "list",
          version: 1,
          listType: "bullet",
          start: 1,
          tag: "ul",
        },
        {
          children: [],
          direction: "ltr",
          format: "",
          indent: 0,
          type: "paragraph",
          version: 1,
        },
        {
          children: [
            {
              detail: 0,
              format: 0,
              mode: "normal",
              style: "",
              text: "Your feedback is valuable and helps us improve the system.",
              type: "text",
              version: 1,
            },
          ],
          direction: "ltr",
          format: "",
          indent: 0,
          type: "paragraph",
          version: 1,
        },
      ],
      direction: "ltr",
      format: "",
      indent: 0,
      type: "root",
      version: 1,
    },
  },
};
